{
    const template = `
            <style>
            .dn{
                display: none;
            }
            .select-container {
                width: 100%;
                height: 40px;
                min-width: 150px;
                position: relative;
            }
            .select-selected {
                width: 100%;
                position: relative;
                background-color: #ffffff;
                border: 1px solid #A5A5A5;
                border-radius: 5px;
                box-sizing: border-box;
            }
            .select-selected:after {
                position: absolute;
                content: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='9' viewBox='0 0 14 9'><path fill='%23454545' d='M6.211,1.015a1,1,0,0,1,1.579,0l4.955,6.371A1,1,0,0,1,11.955,9H2.045a1,1,0,0,1-.789-1.614Z'></path></svg>");
                display: inline-block;
                top: 2px;
                right: 10px;
                transform: rotateX(180deg);
            }
            .select-selected.select-arrow-active:after {
                top: -2px;
                transform: rotateX(0deg);
            }
            ::slotted(li), .select-selected {
                font-size: 16px !important;
                color: #454545;
                line-height: 40px;
                padding: 0px 16px;
                cursor: pointer;
            }
            .click-disable {
                pointer-events: none;
            }
            .select-items {
                width: 100%;
                padding: 0px 0px !important;
                margin: 0px 0px !important;
                background-color: #ffffff;
                border: 1px solid #A5A5A5;
                border-radius: 5px;
                box-sizing: border-box;
                box-shadow: 0px 0px 8px rgba(0,0,0,0.1);
                position: absolute;
                top: 41px;
                left: 0;
                right: 0;
                z-index: 2000;
                max-height: 265px;
                overflow-y: auto;
            }
            ::slotted(li) {
                display: block;
                padding-left: 12px!important;
                padding-right: 12px!important;
                background-color: #ffffff;
                border-bottom: 1px solid #dddddd;
                box-sizing: border-box;
                list-style: none;
                transition: 0.3s;
            }
            ::slotted(li:nth-last-child(1)) {
                border-bottom: none;
            }
            ::slotted(li:hover) {
                background-color: #F5F5F5;
            }

            .select-hide {
                display: none;
            }
            .select-items div:hover {
                background-color: rgba(0, 0, 0, 0.1);
                
            }
            </style>
            <div class="select-container">
                <div class="select-selected click-disable">-</div>
                <ul class="select-items select-hide">
                    <slot name="li"></slot>
                </ul>
            </div>
            
    `;
    
    customElements.define('eh-form-select', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            shadowRoot.innerHTML = template;
            
            //尋找所有 eh-form-select
            let allEhFormSelect = document.querySelectorAll("eh-form-select");

            //找到 custom select
            this.cSelect = this.shadowRoot.querySelector(".select-selected");
            let cSelect = shadowRoot.querySelector(".select-selected");

            //找到 Slot
            this.slotLi = this.shadowRoot.querySelector(`slot[name="li"]`).assignedNodes({flatten: true});
            this.liSlot = this.shadowRoot.querySelector(`slot[name="li"]`);

            //custom select 點擊展開選單
            cSelect.addEventListener("click", function(e) {
                e.stopPropagation();
                if(this){
                    if(this.classList.contains("select-arrow-active")){
                        shadowRoot.querySelector('.select-items').classList.add("select-hide");
                        this.classList.remove("select-arrow-active");
                    }
                    else{
                        allEhFormSelect = document.querySelectorAll("eh-form-select");
                        for(let i = 0; i < allEhFormSelect.length; i++){
                            allEhFormSelect[i].shadowRoot.querySelector('.select-selected').classList.remove("select-arrow-active");
                            allEhFormSelect[i].shadowRoot.querySelector('.select-items').classList.add("select-hide");
                        }
                        shadowRoot.querySelector('.select-items').classList.toggle("select-hide");
                        this.classList.toggle("select-arrow-active");
                    }
                }
            });
            
            //點擊非select物件(document) 收合select
            document.addEventListener("click", function() {
                allEhFormSelect = document.querySelectorAll("eh-form-select");
                for(let i = 0; i < allEhFormSelect.length; i++){
                    allEhFormSelect[i].shadowRoot.querySelector('.select-items').classList.add("select-hide");
                    allEhFormSelect[i].shadowRoot.querySelector(".select-selected").classList.remove("select-arrow-active");
                }
            });
        }

        slotChange() {
            const addClickEvent = () => {
                this.slotLi = this.shadowRoot.querySelector(`slot[name="li"]`).assignedNodes({flatten: true});
                if(this.slotLi.length !== 0){
                    this.value = this.slotLi[0].getAttribute('value');
                    this.cSelect.classList.remove('click-disable');
                    this.slotLi.forEach(element => {
                        element.classList.remove('dn');
                        element.addEventListener("click", function (e){
                            e.stopPropagation();
                            this.parentNode.setAttribute('value', element.getAttribute('value'));
                            this.parentNode.cSelect.click();
                        });
                    });
                }
                else{
                    this.value = '';
                    this.cSelect.innerText = '-';
                    this.cSelect.classList.add('click-disable');
                }
            }
            
            this.liSlot.addEventListener("slotchange", function(){
                addClickEvent();
            })
        }
        connectedCallback() {
            if (!this.hasAttribute('value')) {
                if(this.slotLi){
                    this.slotChange();
                }
                else{
                    this.setAttribute('value', '');
                }
            }
        };

        static get observedAttributes() {
            return ['value'];
        };
        
        attributeChangedCallback(name, oldValue, newValue) {
            if(this.slotLi.length !== 0){
                let found = this.slotLi.find(element => element.getAttribute('value') == this.value);
                this.cSelect.innerText = found.innerText;
                
            }
            else{
                this.cSelect.innerText = '-';
            }
            this.dispatchEvent(new Event('change'));
            
        };

        get value() {
            return this.getAttribute('value');
        };

        set value(newValue) {
            this.setAttribute('value', newValue);
        };
    });
}
